package com.iptvplayer.shared.data.remote

/**
 * A provider (IPTV panel or M3U host) answered with a non-2xx status. Thrown
 * instead of letting `.body()` fail with a confusing deserialization error when
 * the panel is down (e.g. a Cloudflare "error code: 502" text page), so sync
 * can classify the failure for the user.
 */
class ProviderHttpException(val status: Int) : Exception("Provider returned HTTP $status")
